import { createActionTypes } from "@helpers/redux-helpers";

export const getCreatorsListActionTypes = createActionTypes("creators/getList");
